import { personAddressEnumOptions } from './../../../../../../../../types/src/services/enum/person-address.enum';
import { Component, computed, effect, inject, input, output, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { ConfirmBuilder } from '../../../../shared/service/confirm.builder';
import { TableColumn, TableColumnType } from '../../../../shared/components/kit/table/table.types';
import { PersonAddressDialogComponent } from '../person-address-dialog/person-address-dialog.component';
import { FilterBuilder } from '../../../helper/filter.builder';
import { dateColumn } from '../../../../shared/components/kit/table/table.fields';
import { FilterInput } from '@it2go/data-grid';
import { PersonAddressesStore } from './person-addresses.store';
import { TableComponent } from '../../../../shared/components/kit/table/table.component';
import { BaseDialogService } from '../../../../../components/kit/base-dialog/base-dialog-service';
import { translate } from '../../../../shared/shared.global-service';
import { CardTableComponent } from '../../../../shared/components/kit/table/card-table.component';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-person-addresses',
    templateUrl: './person-addresses.component.html',
    styleUrl: './person-addresses.component.scss',
    providers: [PersonAddressesStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CardTableComponent,
        PrimeTemplate,
        TranslatePipe,
    ],
})
export class PersonAddressesComponent {

    public readonly dialogService = inject(BaseDialogService);
    public readonly confirm = inject(ConfirmBuilder);
    public readonly store = inject(PersonAddressesStore);

    public personId = input<number | null>(null);
    public canEdit = input(true);

    protected personAddressTable = viewChild<TableComponent>('personAddressTable');

    public newAddress = output<object>();
    public addresses: any[] = [];

    protected additionalFilter = computed<FilterInput[][]>(() =>
        FilterBuilder.filter({ personId: this.personId() || 0 }).filter || [],
    );

    protected columns: TableColumn[] = [
        {
            name: 'type',
            filterable: {
                type: 'select',
                selectOptions: () => personAddressEnumOptions,
            },
            type: TableColumnType.String50,
        },
        {
            name: 'address',
            type: TableColumnType.MapLink,
        },
        { ...dateColumn, name: 'validFrom' },
        { ...dateColumn, name: 'validTo' },
    ];

    constructor() {
        this.store.onSuccess(
            () => this.personAddressTable()?.reload(),
            'createPersonAddress',
            'updatePersonAddress',
            'deletePersonAddress',
        );

        effect(() => {
            this.personId();
            this.personAddressTable()?.reload();
        });
    }

    protected async addressDetail(item?: any): Promise<void> {
        const data = item ? { address: item, personId: this.personId() } : { personId: this.personId() };

        this.dialogService.open(PersonAddressDialogComponent, {
            header: translate.instant('person.address.label'),
            maximizable: true,
            data: data,
        }).onClose.subscribe((address) => {
            if (!address) return;

            this.newAddress.emit(address);
            if (!this.personId()) {
                this.addresses = [
                    ...this.addresses,
                    address,
                ];
            }
        });
    }

    protected deleteAddress(item: any): void {
        this.confirm.confirmDelete(
            () => {
                if (this.personId()) {
                    this.store.api.deletePersonAddress({ id: item.item.id });
                } else {
                    this.addresses = [...this.addresses.filter((_, index) => index !== item.rowIndex)];
                }
            },
            item,
        );
    }
}
